<template>
  <div>
    <l-geo-json
        ref="rutas"
        :geojson="rutasFiltradas"
        :options="optRutas"
        :optionsStyle="estiloRutas"
        @ready="cargado"
    ></l-geo-json>
  </div>
</template>

<script>
import {LGeoJson} from 'vue2-leaflet';

export default {
  name: "Rutas",
  props: ['geojson','visibles'],
  data() {
    return {
      optRutas: {
        onEachFeature: this.clickRuta
      },
      estiloRutas: {
        color: '#7f054c',
        weight: 6,
        opacity: 1
      },
      estiloRutasOver: {
        color: '#0000a8',
        weight: 10,
        opacity: 1
      },
      estiloRutasSeleccionada: {
        color: '#ff0000',
        weight: 6,
        opacity: 0.5
      },
      geometrias: null
    }
  },
  created() {
    this.geometrias = Object.assign({}, this.geojson)
  },
  computed: {
    rutasFiltradas: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.geometrias = Object.assign({}, this.geojson)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.geometrias.features = this.geometrias.features.filter((ruta) =>
        this.visibles.includes(ruta.properties.id.toString())
      )

      return this.geometrias
    },
  },
  methods: {
    clickRuta(feature, layer) {
      layer.on({
        click: () => {
          this.$emit('rutaSeleccionada', {ruta: feature.properties, capa: layer})
          this.estableceEstilo(layer)
        }
      })
      layer.on({
        mouseover: () => {
          if(layer.options.opacity === 1){
              layer.setStyle(this.estiloRutasOver)
          }
        }
      })
      layer.on({
        mouseout: () => {
          if(layer.options.opacity === 1){
            layer.setStyle(this.estiloRutas)
            layer.setStyle({opacity: 1})
          }
        }
      })
    },
    estableceEstilo(capa) {
      this.$refs.rutas.mapObject.eachLayer( layer => {
        if(layer === capa)
          layer.setStyle(this.estiloRutasSeleccionada)
        else
          layer.setStyle(this.estiloRutas)
      })
    },
    cargado() {
      this.$emit('centrar', {bounds: this.$refs.rutas.mapObject.getBounds()})
    }
  },
  components: {
    LGeoJson
  }
}
</script>

<style scoped>

</style>